import React, {useContext, useEffect, useState } from 'react';
import {  Typography } from '@mui/material';
import Paper from '@mui/material/Paper';
import { makeStyles } from '@mui/styles';
import UserContext from '../../contexts/UserContext';
import Header from '../general/Header';
import axios from '../../api/axios';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';

const useStyles = makeStyles((theme) => ({
	wrapper: {
		maxWidth: 1000,
		marginLeft: "auto",
		marginRight: "auto",
        marginTop: '150px',
        padding: '10px'
	},
    underLine: {
        textDecoration: 'underline'
    },
    marginTop: {
        marginTop: '10px;'
    },
    paddingTopBottom: {
        paddingTop: '20px;',
        paddingBottom: '20px;'
    },
    bar: {
        padding: '10px',
        marginTop: '10px'
    },
    dialog: {
        minWidth: '300px'
    }
})); 


const Users = () => {
    const userContext = useContext(UserContext);
    const classes = useStyles();
    const [users, setUsers] = useState([]);
    const getToken = userContext.checklocalStorage();
    const [openDeleteUser, setOpenDeleteUser] = useState(null);
    const [openAddUser, setOpenAddUser] = useState(false);
    const [openEditUser, setOpenEditUser] = useState(false);
    const [newUser, setNewUser] = useState({email:"",password:""});
    const [editUser, setEditUser] = useState({ id:"", email:"",password:""});

    useEffect(() => {
        fetchUsers();
    }, []);

    const fetchUsers = () => {
		const options = {
			url: `/users/view-users`,
			method: 'get',
			headers: getToken
		};
		
		return axios(options)
            .then((res) => {
                setUsers(res.data.response)
            })
    	.catch((error) => { console.log(error); });
	
	};

    const addUser = () => {

        const options = {
            url: `/auth/register`,
            data: {
                email: newUser.email,
                password: newUser.password
            },
            method: 'post',
            headers: getToken
        };
        
        return axios(options)
                .then((res) => {
                    fetchUsers();
                })
        .catch((error) => { console.log(error); });

    }

    const deleteUser = () => {

        const options = {
            url: `/users/delete-user/${openDeleteUser}`,
            method: 'delete',
            headers: getToken
        };
        
        return axios(options)
            .then((res) => {
                fetchUsers();
            })
        .catch((error) => { console.log(error); });
    }

    const editExistingUser = (user) => {
        
        // console.log(user.id)

        const options = {
            url: `/users/edit-user/${user.id}`,
            data: {
                email: user.email,
                password: user.password
            },
            method: 'patch',
            headers: getToken
        };
        
        return axios(options)
                .then((res) => {
                    fetchUsers();
                })
        .catch((error) => { console.log(error); });
    }

    return (
        <>
            <Header /> 
            <Paper className={classes.wrapper}>
            <Grid item xs={12} >   
                <Button variant="outlined" onClick={() => { setOpenAddUser(true)}} startIcon={<AddIcon />}>
                    Benutzer hinzufügen
                </Button>
            </Grid>
            { users.map((user) => (
                <Paper key={user.id} className={classes.bar}>

                     <Grid container spacing={2} >
                        <Grid item xs={8} >   
                            <Typography>{user.email}</Typography>
                        </Grid>
                        <Grid item xs={2} >   
                            <Button variant="outlined" onClick={() => {
                                setOpenEditUser(true);
                                setEditUser({
                                    id:user.id, email:user.email 
                                  })
                            }} startIcon={<EditIcon />}>
                                Bearbeiten
                            </Button>
                        </Grid>
                        <Grid item xs={2} >   
                            <Button variant="outlined" onClick={() => {setOpenDeleteUser(user.id)}} startIcon={<DeleteForeverIcon />}>
                                Löschen
                            </Button>
                        </Grid>
                    </Grid>
                </Paper>
            ))}
            </Paper>
            <Dialog
                open={ openDeleteUser !== null }
                onClose={() => {setOpenDeleteUser(null)}}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                {"Benutzer löschen"}
                </DialogTitle>
                <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    Sind Sie sicher, dass Sie den Benutzer löschen möchten?
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                <Button onClick={() => {
                    setOpenDeleteUser(null);
                    deleteUser();
                }
                }>löschen</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={ openAddUser }
                onClose={() => {setOpenAddUser(false)}}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                {"Benutzer hinzufügen"}
                </DialogTitle>
                <DialogContent>
                    <TextField
                        id="loginform-email"
                        label="E-Mail Adresse"
                        placeholder="E-Mail"
                        margin="normal"
                        variant="outlined"
                        required={true}
                        fullWidth={true}
                        autoComplete="email"
                        type="email"
                        autoFocus
                        value={newUser.email}
                        onChange={(e)=> setNewUser({ ...newUser, email: e.target.value })}
                    />
                    <TextField
                        id="loginform-password"
                        label="Passwort"
                        type="password"
                        placeholder="Passwort"
                        margin="normal"
                        variant="outlined"
                        required={true}
                        fullWidth={true}
                        value={newUser.password}
                        onChange={(e)=> setNewUser({ ...newUser, password: e.target.value })}
                        autoComplete="current-password"
                    />
                </DialogContent>
                <DialogActions>
                <Button 
                    onClick={() => { 
                        setOpenAddUser(false);
                        addUser();
                        }
                    }
                    disabled={ newUser.email  === "" || newUser.password === ""}
                >hinzufügen</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={ openEditUser }
                onClose={() => {setOpenEditUser(false)}}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                {"Benutzer hinzufügen"}
                </DialogTitle>
                <DialogContent>
                    <TextField
                        id="loginform-email"
                        label="E-Mail Adresse"
                        placeholder="E-Mail"
                        margin="normal"
                        variant="outlined"
                        required={true}
                        fullWidth={true}
                        autoComplete="email"
                        type="email"
                        autoFocus
                        value={editUser.email}
                        onChange={(e)=> setEditUser({ ...editUser, email: e.target.value })}
                    />
                    <TextField
                        id="loginform-password"
                        label="Passwort"
                        type="password"
                        placeholder="Passwort"
                        margin="normal"
                        variant="outlined"
                        required={true}
                        fullWidth={true}
                        value={editUser.password ? editUser.password : ''}
                        onChange={(e)=> setEditUser({ ...editUser, password: e.target.value })}
                        autoComplete="current-password"
                    />
                </DialogContent>
                <DialogActions>
                <Button 
                    onClick={() => { 
                        setOpenEditUser(false);
                        editExistingUser(editUser);
                        }
                    }
                    disabled={ !editUser.email  || !editUser.password }
                >hinzufügen</Button>
                </DialogActions>
            </Dialog>
        </>
	);
}

export default Users;